import { get } from 'lodash'
import { BADGE_LEVELS } from '../constants/enums'

export const getBadgeIconImg = (award, badge, isObtained) => {
  const awardLvl = get(award, 'awardLevel')

  // eslint-disable-next-line no-use-before-define
  return getBadgeIconImgByNames(awardLvl, badge, isObtained)
}

export const getBadgeIconImgByNames = (awardLvl, badge, isObtained) => {
  const imgMap = get(badge, 'organizationBadgeConfiguration.imageMap')

  if (awardLvl && imgMap && imgMap[awardLvl.value]) {
    return isObtained ? imgMap[awardLvl.value].active : imgMap[awardLvl.value].inactive
  } else {
    return ''
  }
}

export const getActivityBadgeColor = (activity) => {
  const activitySection = activity && get(activity, 'activitySection.value')

  switch (activitySection) {
    case 'SKILL': return 'skillColor'
    case 'SERVICE': return 'serviceColor'
    case 'PHYSICAL_RECREATION': return 'physrecColor'
    default: return ''
  }
}

export const calculateWeekBlock = (activity, badge, badgeThreshold, apprenticeBadgeThreshold, isBadgesStrictModeEnabled) => {
  const totalHours = get(activity, 'total') / 60 / 60

  const threshold = get(badgeThreshold, 'intValue')

  if (isBadgesStrictModeEnabled) {
    return Math.floor(((totalHours / 100) * threshold))
  } else {
    const weekBlock = Math.floor(((totalHours / 100) * get(apprenticeBadgeThreshold, 'intValue')))

    let count = 1

    const badgeLvl = get(badge, 'badgeLevel.value')

    switch (badgeLvl) {
      case BADGE_LEVELS.apprentice.id:
        count = 1
        break
      case BADGE_LEVELS.master.id:
        count = 2
        break
      case BADGE_LEVELS.hero.id:
        count = 3
        break
      default:
        break
    }

    return `${count}x${weekBlock}`
  }
}
